/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Tools_Submit_DescriptionInputs */

const en_directory_tools_submit_description = /** @type {(inputs: Directory_Tools_Submit_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share an AI tool for review and discovery.`)
};

const zh_directory_tools_submit_description = /** @type {(inputs: Directory_Tools_Submit_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交一个 AI 工具，审核后进入目录发现流。`)
};

/**
* | output |
* | --- |
* | "Share an AI tool for review and discovery." |
*
* @param {Directory_Tools_Submit_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_tools_submit_description = /** @type {((inputs?: Directory_Tools_Submit_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Tools_Submit_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_tools_submit_description(inputs)
	return zh_directory_tools_submit_description(inputs)
});
export { directory_tools_submit_description as "directory.tools.submit.description" }